import { inject } from '@angular/core';
import { environmentBrand } from '@lentau/ui-kit/core/environments/environment.brand';
import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';
import { DomNewSiteRedirectDomStrategy } from './dom-new-site-redirect.dom.strategy';
import { DomNewSiteRedirectNoopStrategy } from './dom-new-site-redirect.noop.strategy';
import { DomNewSiteRedirectStrategy } from './dom-new-site-redirect.strategy';

export const getDomNewSiteRedirectStrategy: () => DomNewSiteRedirectStrategy = () => {
  const factoryByBrand: Partial<Record<RetailBrands, () => DomNewSiteRedirectStrategy>> = {
    [RetailBrands.DOM]: (): DomNewSiteRedirectStrategy => inject(DomNewSiteRedirectDomStrategy),
  };

  const createStrategy: (() => DomNewSiteRedirectStrategy) | undefined = factoryByBrand[environmentBrand.BRAND];
  return createStrategy ? createStrategy() : inject(DomNewSiteRedirectNoopStrategy);
};
